var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConcertDj(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.942 22.088L22.514 17.088C22.3276 16.4453 21.7401 16.0023 21.071 16H2.929C2.25978 16.0021 1.67207 16.4452 1.486 17.088L0.0579987 22.088C-0.0712585 22.5405 0.0193481 23.0275 0.302719 23.4032C0.586098 23.7789 1.02938 23.9999 1.5 24H22.5C22.9706 23.9999 23.4139 23.7789 23.6973 23.4032C23.9807 23.0275 24.0713 22.5405 23.942 22.088ZM7.01 22C5.328 22 4.01 21.121 4.01 20C4.01 18.879 5.328 18 7.01 18C8.692 18 10.01 18.879 10.01 20C10.01 21.121 8.692 22 7.01 22ZM14 20C14 21.121 15.318 22 17 22C18.682 22 20 21.121 20 20C20 18.879 18.682 18 17 18C15.318 18 14 18.879 14 20Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10C13.6569 10 15 8.65685 15 7C15 5.34315 13.6569 4 12 4C10.3431 4 9 5.34315 9 7C9 8.65685 10.3431 10 12 10Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.685 14.5C16.8584 14.4985 17.0191 14.4085 17.1109 14.2614C17.2027 14.1142 17.2129 13.9304 17.138 13.774C16.207 11.7771 14.2033 10.5005 12 10.5005C9.79673 10.5005 7.79303 11.7771 6.862 13.774C6.78708 13.9304 6.79731 14.1142 6.88912 14.2614C6.98093 14.4085 7.14158 14.4985 7.315 14.5H16.685Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.178 4.34402C18.0263 4.30188 17.9032 4.19072 17.846 4.04402C16.9284 1.61407 14.6034 0.00496785 12.006 0.00207909C9.40855 -0.000809673 7.08005 1.60312 6.157 4.03102C6.10024 4.18058 5.97534 4.29395 5.821 4.33602C4.61232 4.66145 3.83062 5.83062 3.99178 7.07193C4.15294 8.31323 5.20729 9.24402 6.459 9.25002H7.5C7.77614 9.25002 8 9.02616 8 8.75002V5.00002C7.9997 4.86741 8.02623 4.7361 8.078 4.61402C8.73783 3.03084 10.2848 1.99962 12 1.99962C13.7152 1.99962 15.2622 3.03084 15.922 4.61402C15.9733 4.73624 15.9998 4.86745 16 5.00002V8.75002C16 9.02616 16.2239 9.25002 16.5 9.25002H17.5C18.7481 9.24947 19.8045 8.32856 19.9754 7.09226C20.1462 5.85596 19.3791 4.68303 18.178 4.34402Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConcertDj);
export default __webpack_public_path__ + "static/media/concertDj.756a9ce1.svg";
export { ForwardRef as ReactComponent };